import { render, staticRenderFns } from "./ClassroomDetailPage.vue?vue&type=template&id=6586ad41&scoped=true"
import script from "./ClassroomDetailPage.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailPage.vue?vue&type=style&index=0&id=6586ad41&prod&lang=stylus&scoped=true"
import style1 from "./ClassroomDetailPage.vue?vue&type=style&index=1&id=6586ad41&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586ad41",
  null
  
)

export default component.exports